import { Box } from '@chakra-ui/react';

import { TextRegular } from 'UiKit/typography';

import styles from './styles.module.css';

const ColumnHostName = ({ values }) => {
  return (
    <Box className={styles['column__container']}>
      <TextRegular className={styles['column__text--host-name']}>{values?.hostName}</TextRegular>
      <TextRegular className={styles['column__text--brand']}>{values?.brandName}</TextRegular>
    </Box>
  );
};

export default ColumnHostName;
